export default __webpack_public_path__ + "static/media/Knife_1.722da93c.png";